import React, { useState } from "react";
import Checkout from "../../components/checkout/Checkout"
import TestCardsTable from "../../components/checkout/TestCardsTable"


export default function RetailHome(){
    const [mobileView, setMobileView] = useState(false);

    const pageContent = (
        <div className={`min-h-screen ${mobileView ? 'bg-white px-3 pt-0 pb-2' : 'bg-gray-50 p-4'}`}>
            <div className={mobileView ? 'max-w-full' : 'max-w-7xl mx-auto space-y-8'}>
                <div className={mobileView ? 'w-full' : 'w-full bg-white p-6 rounded-lg shadow-sm border border-gray-200 max-w-3xl mx-auto'}>
                    <Checkout/>
                </div>
                
                {/* Test Cards Table — hidden in mobile view */}
                {!mobileView && <TestCardsTable />}
            </div>
        </div>
    );

    return (
        <div>
            {/* Mobile view toggle */}
            <div className="fixed top-20 right-4 z-50 flex items-center gap-2 bg-white border border-gray-200 rounded-full px-3 py-1.5 shadow-sm">
                <label className="flex items-center gap-1.5 text-xs text-gray-500 cursor-pointer select-none">
                    <input
                        type="checkbox"
                        checked={mobileView}
                        onChange={(e) => setMobileView(e.target.checked)}
                        className="w-3 h-3"
                    />
                    Mobile
                </label>
            </div>

            <div className={mobileView ? 'min-h-screen bg-gray-200 flex items-start justify-center pt-8 pb-8' : ''}>
                <div className={mobileView ? 'relative w-[390px] h-[844px]' : ''}>
                    {mobileView && (
                        <>
                            <div className="absolute inset-0 bg-black rounded-[3rem] shadow-2xl z-0"></div>
                            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-black rounded-b-2xl z-20"></div>
                        </>
                    )}
                    <div className={mobileView
                        ? 'absolute inset-[12px] bg-white rounded-[2.4rem] overflow-y-auto overflow-x-hidden z-10 scrollbar-hide'
                        : ''
                    }
                    style={mobileView ? { scrollbarWidth: 'none', msOverflowStyle: 'none' } : {}}
                    >
                        {pageContent}
                    </div>
                </div>
            </div>
        </div>
    );
}
